import { render, staticRenderFns } from "./GoogleBtn.vue?vue&type=template&id=188dc6f6"
import script from "./GoogleBtn.vue?vue&type=script&lang=js"
export * from "./GoogleBtn.vue?vue&type=script&lang=js"
import style0 from "./GoogleBtn.vue?vue&type=style&index=0&id=188dc6f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports